import axios from "axios";

// Set the rails csrf token in axios
const tokenTag = document.getElementsByName("csrf-token")[0];
const token = tokenTag ? tokenTag.getAttribute("content") : "";
axios.defaults.headers.common["X-CSRF-Token"] = token;
axios.defaults.headers.common.Accept = "application/json";
